import { render, staticRenderFns } from "./deliveries.vue?vue&type=template&id=32eeb54b"
import script from "./deliveries.vue?vue&type=script&lang=js"
export * from "./deliveries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports